/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 10:04:38 
 * @Last Modified by: jingyu.yang
 * @Last Modified time: 2022-02-22 13:50:34
 */
<template>
  <div class="upload">
    <div class="upload-input" @click="getFile">
      <div class="upload-btn">
        <slot />
      </div>
    </div>
    <input
      :accept="accepts"
      ref="fileUpload"
      class="fileUpload"
      type="file"
      name="file"
      title=" "
      @change="onChange"
    />
  </div>
</template>
<script>
import UploadMixin from "./upload";
export default {
  name: "Upload",
  components: {},
  mixins: [UploadMixin],
  props: {
    share: {
      type: Boolean,
      required: false,
      default: true,
    },
    beforeUpload: Function,
  },
  computed: {
    accepts() {
      return this.fileTypes.map((v) => `.${v}`).join(",");
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    uid() {
      return this.userInfo?.uid;
    },
    liveStartStatus() {
      return this.$store.getters.liveRoomStatus;
    },
  },
  watch: {
    allFiles: {
      handler(newval) {
        console.log(newval, "allFiles变化调用change");
        this.$emit("change", newval);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    updateFiles() {
      this.getLists();
    },
    onChange() {
      let files = this.$refs.fileUpload.files;
      let file = files[0];
      if (this.fileSize > 0) {
        if (file.size / 1024 / 1024 > this.fileSize) {
          this.$emit("on-error", {
            type: "fileSize",
            file: file,
          });
          this.$refs.fileUpload.value = "";
          return;
        }
      }
      this.fileChange(files);
    },
    getFile() {
      console.log(this.$slots, "this.$slots");
      if (this.$slots?.default[0]?.elm?.disabled) return;
      this.$refs.fileUpload.click();
    },
  },
};
</script>

<style scoped lang="scss">
.upload-input {
  display: inline-block;
  cursor: pointer;
}
input {
  width: 0;
  height: 0;
  opacity: 0;
}
.upload-btn {
  width: 100%;
  height: 100%;
}
</style>
